/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Seat_Change_Confirm_ScheduleInputs */



/**
* | output |
* | --- |
* | "Change on {date}" |
*
* @param {Seat_Change_Confirm_ScheduleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_confirm_schedule = /** @type {((inputs: Seat_Change_Confirm_ScheduleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Confirm_ScheduleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Am ${i?.date} ändern`)
	return /** @type {LocalizedString} */ (`Change on ${i?.date}`)
});